require('./brokerHireDerivativesAccountStep2.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');

// @components
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @helpers
const { FormattedText } = require('core/i18n').i18n;

// @constants
const {
    FIRST_STEP,
    SECOND_STEP,
    BROKER_HIRE_DERIVATIVES_ACCOUNT_SIGNATURE_PATTERN_TYPE,
    CHARGE_ACCOUNT_PREFIX
} = require('constants/index');

const CLASS_NAME = 'broker-hire-derivatives-account-step2';

const BrokerHireDerivativesAccountStep2 = props => {
    const {
        immBrokerHireDerivativesAccount,
        onChangeAcceptManifest,
        actions,
        cancelButton,
        nextButton
    } = props;

    const selectedAssociatedContract = immBrokerHireDerivativesAccount.getIn(
        ['steps', FIRST_STEP, 'selectedAssociatedContract']
    );
    const immSelectedAssociatedAccount = immBrokerHireDerivativesAccount.getIn(
        ['contracts', selectedAssociatedContract]
    );

    const manifest = immBrokerHireDerivativesAccount.getIn(['steps', SECOND_STEP, 'acceptedManifest']);

    const product = immSelectedAssociatedAccount.get('product');
    const contractNumber = immSelectedAssociatedAccount.get('contractNumber');

    const signaturePatternParams = {
         originAccount: `${CHARGE_ACCOUNT_PREFIX}${product}${contractNumber}`
    };

    const contractualInformation = (
        <OKLink modifier="emphasize">
            <FormattedText value="hireDerivativesAccount-contractualInformation"/>
        </OKLink>
    );

    const contractServices = (
        <OKLink modifier="emphasize">
            <FormattedText value="hireDerivativesAccount-contractServices"/>
        </OKLink>
    );

    const regulationMeff = (
        <OKLink modifier="emphasize">
            <FormattedText value="hireDerivativesAccount-regulationMeff"/>
        </OKLink>
    );

    const variableRentMeff = (
        <OKLink modifier="emphasize">
            <FormattedText value="hireDerivativesAccount-variableRentMeff"/>
        </OKLink>
    );

    const regulationEurex = (
        <OKLink modifier="emphasize">
            <FormattedText value="hireDerivativesAccount-regulationEurex"/>
        </OKLink>
    );

    const commissionsInForce = (
        <OKLink modifier="emphasize">
            <FormattedText value="hireDerivativesAccount-commissionsInForce"/>
        </OKLink>
    );

    const howToOperate = (
        <OKLink modifier="emphasize">
            <FormattedText value="hireDerivativesAccount-howToOperate"/>
        </OKLink>
    );

    const manifestLabel = (
        <FormattedTextWithComponents
            value="hireDerivativesAccount-manifest"
            injectedComponents={[
                contractualInformation,
                contractServices,
                regulationMeff,
                variableRentMeff,
                regulationEurex,
                commissionsInForce,
                howToOperate
            ]}
        />
    );

    return (
        <WizardStep
            actions={actions}
            cancelButton={cancelButton}
            nextButton={nextButton}
            immFinalButton="hireDerivativesAccount-contract"
            position="last"
        >
            <h4 className={`${CLASS_NAME}__header-title`}>
                <FormattedText value="hireDerivativesAccount-securityConfirmation"/>
            </h4>
            <div className={`${CLASS_NAME}__field`}>
                <FormattedText value="hireDerivativesAccount-verifyInformation"/>
            </div>
            <div className={`${CLASS_NAME}__field`}>
                <OKCheckbox
                    idName="hireDerivativesAccount"
                    label={manifestLabel}
                    value={manifest}
                    onChange={onChangeAcceptManifest}
                />
            </div>
            <div className={`${CLASS_NAME}__signature-pattern`}>
                <SignaturePattern
                    operationType={BROKER_HIRE_DERIVATIVES_ACCOUNT_SIGNATURE_PATTERN_TYPE}
                    operationParams={signaturePatternParams}
                />
            </div>
        </WizardStep>
    );
};

BrokerHireDerivativesAccountStep2.propTypes = {
    immBrokerHireDerivativesAccount: PropTypes.object.isRequired,
    onChangeAcceptManifest: PropTypes.func.isRequired,
    actions: PropTypes.object.isRequired,
    cancelButton: PropTypes.bool,
    nextButton: PropTypes.bool
};

BrokerHireDerivativesAccountStep2.defaultProps = {
    cancelButton: true,
    nextButton: true
}

module.exports = BrokerHireDerivativesAccountStep2;